export const dlWishlistAddEvent = (product, last3Items) => {
    window.dataLayer.push({
        event: 'Add to wishlist',
        wishlist: {
            product: {
                handle: product.handle,
                id: product.id,
                image: product.image,
                sku: product.sku,
                title: product.title,
                url: product.url
            },
            last_3_items: last3Items,
            last_3_ids: last3Items.map(item => item.product_id),
            location: window.location.pathname
        }
    });
};
